const route = {
	name: 'diagnosis',
	path: 'diagnosis',
	component: () => import('@/pages/diagnosis/page-diagnosis'),
	meta: {
		title: 'Diagnóstico',
	},
	props: true,
	children: [
		{
			name: 'diagnoses',
			path: 'diagnoses',
			component: () => import('@/pages/diagnosis/page-diagnosis-diagnoses'),
			meta: {
				title: 'Diagnóstico',
			},
			props: true,
			children: [
				{
					name: 'detail-diagnoses',
					path: ':toolId?/detail/:id',
					component: () => import('@/pages/diagnosis/page-diagnoses-detail'),
					meta: {
						title: 'Diagnóstico',
					},
					props: true,
					children: [
						{
							name: 'detail-summary-inventory',
							path: ':toolId?/inventory/:idsummary',
							component: () => import('@/pages/diagnosis/page-inv-summary'),
							meta: {
								title: 'Diagnóstico',
							},
							props: true,
						},
						{
							name: 'detail-diagnosis-weather',
							path: ':toolId?/weather/:idsummary',
							component: () => import('@/pages/diagnosis/page-weather-summary'),
							meta: {
								title: 'Diagnóstico clima laboral',
							},
							props: true,
						},
						{
							name: 'detail-summary-diagnoses',
							path: ':toolId?/diagnoses/:detailId',
							component: () => import('@/pages/diagnosis/page-diagnoses-summary'),
							meta: {
								title: 'Diagnóstico',
							},
							props: true,
						},
						{
							name: 'detail-summary-graphic-inventory',
							path: ':toolId?/graphic-inventory/:idsummary/:areaId?/:subsidiaryId?',
							component: () => import('@/pages/diagnosis/page-inv-graphic-summary'),
							meta: {
								title: 'Diagnóstico',
							},
							props: true,
						},
					],
				},
			],
		},
		{
			name: 'new-diagnosis',
			path: 'new-diagnosis/:toolCode?/:pollId?',
			props: true,
			component: () => import('@/pages/diagnosis/page-diagnosis-new-diagnoses'),
			meta: {
				title: 'Diagnóstico',
			},
		},
	],
};
export default route;



// WEBPACK FOOTER //
// ./src/router/diagnosis/index.js